"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _withProps = _interopRequireDefault(require("recompose/withProps"));

var _default = (0, _withProps["default"])(function (_ref) {
  var facility = _ref.facility,
      schemaPromotion = _ref.schemaPromotion;
  var name = facility.name,
      location = facility.location,
      reviews = facility.reviews,
      facilityPhone = facility.facilityPhone,
      imagesWithUrl = facility.imagesWithUrl,
      schemaUrl = facility.schemaUrl;
  var selfStorageSchema = {
    '@context': 'https://schema.org',
    '@type': 'SelfStorage',
    name: name,
    url: schemaUrl,
    priceRange: '$-$$',
    address: {
      '@type': 'PostalAddress',
      addressLocality: location.city,
      addressRegion: location.state,
      postalCode: location.zip,
      streetAddress: location.streetAddress1,
      addressCountry: {
        '@type': 'Country',
        name: 'US'
      }
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: location.latitude,
      longitude: location.longitude
    }
  };

  if (facilityPhone && facilityPhone.length) {
    selfStorageSchema.telephone = facilityPhone;
  }

  if (schemaPromotion && schemaPromotion.length) {
    selfStorageSchema.makesOffer = {
      '@type': 'Offer',
      name: schemaPromotion
    };
  }

  if (imagesWithUrl && imagesWithUrl.length) {
    selfStorageSchema.image = imagesWithUrl.map(function (image) {
      return {
        '@type': 'ImageObject',
        url: image
      };
    });
  }

  if (reviews.number > 0) {
    selfStorageSchema.aggregateRating = {
      '@type': 'AggregateRating',
      ratingCount: reviews.number,
      ratingValue: reviews.average
    };
  }

  var stringifiedSelfStorageSchema = JSON.stringify(selfStorageSchema);
  return {
    selfStorageSchema: stringifiedSelfStorageSchema
  };
});

exports["default"] = _default;